export const CASES = {
    UPDATE_READY_PRODUCTS: 'UPDATE_READY_PRODUCTS',
    CLEAR_READY_PRODUCTS: 'CLEAR_READY_PRODUCTS',
};
